// Navigation
export default function setNav() {
	//Hamburger
	const openNav = document.querySelector(".hamburger");
	if (openNav !== null) {
		const navId = openNav.getAttribute("aria-controls");
		const nav = document.getElementById(navId);
		const toggleNav = () => {
			if (openNav.getAttribute("aria-expanded") === "false") {
				openNav.setAttribute("aria-expanded", "true");
				nav.setAttribute("aria-expanded", "true");
			} else {
				openNav.setAttribute("aria-expanded", "false");
				nav.setAttribute("aria-expanded", "false");
			}
		}
		openNav.addEventListener("click", () => {
			// console.log("burger");
			toggleNav();
		});
	}
};